/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_Baking_AreaInputs */

const en_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baking Area`)
};

const ar_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منطقة الخبز`)
};

const de_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backbereich`)
};

const es_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de horneado`)
};

const fr_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coin pâtisserie`)
};

const it_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area di cottura`)
};

const ja_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベーキングエリア`)
};

const ko_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`베이킹 공간`)
};

const pt_br_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de Assar`)
};

const ru_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зона выпечки`)
};

const th_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โซนอบขนม`)
};

const tr_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pişirme Alanı`)
};

const zh_cn_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙区`)
};

const zh_tw_tab_baking_area = /** @type {(inputs: Tab_Baking_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙區`)
};

/**
* | output |
* | --- |
* | "Baking Area" |
*
* @param {Tab_Baking_AreaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tab_baking_area = /** @type {((inputs?: Tab_Baking_AreaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_Baking_AreaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_baking_area(inputs)
	if (locale === "ar") return ar_tab_baking_area(inputs)
	if (locale === "de") return de_tab_baking_area(inputs)
	if (locale === "es") return es_tab_baking_area(inputs)
	if (locale === "fr") return fr_tab_baking_area(inputs)
	if (locale === "it") return it_tab_baking_area(inputs)
	if (locale === "ja") return ja_tab_baking_area(inputs)
	if (locale === "ko") return ko_tab_baking_area(inputs)
	if (locale === "pt_br") return pt_br_tab_baking_area(inputs)
	if (locale === "ru") return ru_tab_baking_area(inputs)
	if (locale === "th") return th_tab_baking_area(inputs)
	if (locale === "tr") return tr_tab_baking_area(inputs)
	if (locale === "zh_cn") return zh_cn_tab_baking_area(inputs)
	return zh_tw_tab_baking_area(inputs)
});